import { EventType } from '..';
export const pickAwareEvent = (props) => {
    return (({ timeTaken, usageUserId }) => ({
        type: EventType.Aware,
        timeTaken: timeTaken || 0,
        usageUserId: usageUserId || 'Error',
    }))(props || {});
};
//# sourceMappingURL=AwareEvent.js.map